interface UTMParams {
  [key: string]: string;
}

const COOKIE_NAME = 'utm_params';

export const getUTMParams = (): UTMParams => {
  const urlParams = new URLSearchParams(window.location.search);

  const utmKeys: string[] = [
    'utm_medium',
    'utm_source',
    'utm_campaign',
    'utm_id',
    'utm_term',
    'utm_content',
  ];

  const utmObject: UTMParams = {};

  utmKeys.forEach((key) => {
    if (urlParams.has(key)) {
      const value = urlParams.get(key);

      if (value) {
        utmObject[key] = value;
      }
    }
  });

  return utmObject;
};

export const parseUTMCookie = (): UTMParams => {
  const cookies: string[] = document.cookie.split('; ');

  const utmCookie = cookies.find((cookie) =>
    cookie.startsWith(`${COOKIE_NAME}=`),
  );
  if (!utmCookie) return {};

  const utmString = decodeURIComponent(utmCookie.split('=')[1]);
  const utmObject: UTMParams = {};

  utmString.split('&').forEach((param) => {
    const [key, value] = param.split('=');

    if (key && value) {
      utmObject[key] = value;
    }
  });

  return utmObject;
};

export const setUTMCookie = (): void => {
  const newParams = getUTMParams();

  if (Object.keys(newParams).length === 0) {
    return;
  }

  const existingParams: UTMParams = parseUTMCookie();

  const updatedParams: UTMParams = { ...existingParams, ...newParams };

  const utmString: string = Object.entries(updatedParams)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const expires = new Date();
  expires.setDate(expires.getDate() + 7);

  const COOKIE_DOMAIN = import.meta.env.VITE_UTM_COOKIE_DOMAIN;

  document.cookie = `${COOKIE_NAME}=${utmString}; path=/; domain=${COOKIE_DOMAIN}; expires=${expires.toUTCString()}; SameSite=Lax`;
};

export const getUTMCookie = (): string => {
  const cookies: string[] = document.cookie.split('; ');

  const utmCookie = cookies.find((cookie) =>
    cookie.startsWith(`${COOKIE_NAME}=`),
  );

  return utmCookie ? utmCookie?.replace(`${COOKIE_NAME}=`, '') : '';
};
